<template>
  <div class="container">
    <div class="content">
      <h1>MOJE KONTO</h1>
      <div style="margin-top: 40px" class="invite-and-zoom">
        <div class="invite profile-card">
          <ref-links-info
            :userId="profile.id"
            :userRefLinksAmount="profile.refLinksAmount"
          />
        </div>
        <div style="width: 100%" class="">
          <div class="zoom profile-card">
            <div class="sub-title mb-5">nagrania zoom</div>
            <div class="sub-title sub-title-smaller">Ogólne</div>
            <template
              v-if="
                timePackagesLinksForGeneral &&
                timePackagesLinksForGeneral.length
              "
            >
              <div v-for="link in timePackagesLinksForGeneral" :key="link.id">
                <p class="zoom-link">
                  <a :href="link.link" target="_blank">{{ link.name }}</a>
                </p>
              </div>
            </template>
            <template v-else>
              <p class="no-links">Aktualnie brak dostępnych nagrań</p>
            </template>

            <div class="sub-title sub-title-smaller">Początek</div>

            <template
              v-if="
                timePackagesLinksForBeginners &&
                timePackagesLinksForBeginners.length
              "
            >
              <div v-for="link in timePackagesLinksForBeginners" :key="link.id">
                <p class="zoom-link">
                  <a :href="link.link" target="_blank">{{ link.name }}</a>
                </p>
              </div>
            </template>
            <template v-else>
              <p class="no-links">Aktualnie brak dostępnych nagrań</p>
            </template>
          </div>
          <p class="remember-zoom">
            Pamiętaj! Nagrania są dostępne do 48 godzin od zakończenia zajęć.
          </p>
        </div>
      </div>
      <div class="profile-grid">
        <div class="profile-card span-height">
          <div
            style="margin: auto; width: fit-content"
            class="profile-image-section"
          >
            <img
              class="profile-image mb-4"
              :src="imagePath"
              alt="profile-pic"
              loading="lazy"
            />

            <button class="primary-button mb-16" @click="openChangePhotoModal">
              Zmień zdjęcie profilowe
            </button>
          </div>
          <div class="sub-title" style="font-size: 24px">
            {{ this.profile.email }}
          </div>
          <div class="sub-title" style="margin-top: 30px">ZMIEŃ HASŁO</div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form
              ref="form"
              style="max-width: 600px; margin: auto"
              @submit.prevent="handleSubmit(handleChangePassword)"
            >
              <div class="">
                <VTextFieldWithValidation
                  label="Nowe hasło"
                  placeholder="Wpisz hasło..."
                  type="password"
                  color="white"
                  v-model="password"
                />
              </div>

              <div class="" style="margin-top: 20px">
                <VTextFieldWithValidation
                  label="Powtórz nowe hasło"
                  placeholder="Powtórz hasło..."
                  type="password"
                  color="white"
                  v-model="confirmPassword"
                />
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                  "
                  class=""
                >
                  <button
                    style="margin-top: 40px"
                    type="submit"
                    class="primary-button"
                  >
                    Zmień hasło
                  </button>
                  <button class="primary-button" @click="logout">
                    Wyloguj się
                  </button>
                </div>
              </div>
            </v-form>
          </ValidationObserver>

          <div
            v-if="profile.isNewsletterSubscribed"
            style="text-align: center; margin-top: 30px"
          >
            <span
              @click="handleUnsubscribeFromNewsletter"
              style="
                color: #8b857d;
                text-decoration: underline;
                cursor: pointer;
                font-size: 14px;
              "
              class="newsletter-unsubscribe"
            >
              Wypisz się z newslettera
            </span>
          </div>
        </div>
        <div class="profile-card">
          <h2 class="sub-title" style="font-size: 40px">Subskrypcja</h2>

          <div
            class=""
            style="display: flex; align-items: center; margin-top: 30px"
          >
            <h4 class="sub-title sub-title-smaller" style="text-align: left">
              Ogólna:
            </h4>
            <div
              v-if="
                (activeSubscriptions && activeSubscriptions[0]) ||
                currentFrozenSubscription
              "
              class="text-left ml-3 mb-1"
              style="color: #606c38; font-weight: 600"
            >
              <template v-if="currentFrozenSubscription">
                Zamrożona do:
                {{
                  formatDateToString(currentFrozenSubscription.frozenEndDate)
                }}
              </template>
              <template v-else>
                Aktywna do:
                {{ formatDateToString(activeSubscriptions[0].expiration_time) }}
                <span
                  @click="redirect"
                  style="
                    color: #8b857d;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-left: 10px;
                  "
                  >Przedłuż</span
                >
                <span
                  v-if="canFreezeSubscription"
                  @click="handleFreezeSubscription"
                  style="
                    color: #8b857d;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-left: 10px;
                  "
                  >Zamroź dostęp</span
                >
              </template>
            </div>

            <div
              @click="redirect"
              style="cursor: pointer; display: flex; align-items: center"
              class="mb-1"
              v-else
            >
              <a class="redirect-to-subscriptions">Kup subskrypcję</a>
              <svg
                width="31"
                height="16"
                viewBox="0 0 31 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
                  fill="#8B857D"
                />
              </svg>
            </div>
          </div>

          <div style="display: flex; align-items: center; margin-top: 30px">
            <h4 class="sub-title sub-title-smaller" style="text-align: left">
              Początek:
            </h4>
            <div
              v-if="
                activeSubscriptionsForBeginners &&
                activeSubscriptionsForBeginners[0]
              "
              class="text-left ml-3 mb-1"
              style="color: #606c38; font-weight: 600"
            >
              Aktywna do:
              {{
                formatDateToString(
                  activeSubscriptionsForBeginners[0].expiration_time
                )
              }}
              <span
                @click="redirectToSubscriptionsForBeginners"
                style="
                  color: #8b857d;
                  text-decoration: underline;
                  cursor: pointer;
                  margin-left: 10px;
                "
                >Przedłuż</span
              >
            </div>
            <div
              @click="redirectToSubscriptionsForBeginners"
              style="cursor: pointer; display: flex; align-items: center"
              class="mb-1"
              v-else
            >
              <a class="redirect-to-subscriptions">Kup subskrypcję</a>
              <svg
                width="31"
                height="16"
                viewBox="0 0 31 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
                  fill="#8B857D"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="profile-card profile-card-with-button">
          <h2 class="sub-title" style="font-size: 40px">DZIENNIK PRAKTYK</h2>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 6px;
              margin-top: 10px;
              justify-content: center;
            "
          >
            <EyeOffIcon />
            <span style="color: #54514c; font-weight: 500; font-size: 14px"
              >Widoczny tylko dla Ciebie</span
            >
          </div>
          <div class="button-wrapper">
            <button class="primary-button" @click="goToPracticeJournal">
              Przejdź do swoich notatek
            </button>
          </div>
        </div>
        <div
          class="profile-card profile-card-with-button"
          v-if="ticket || ticketBeginners"
        >
          <div class="" v-if="ticket || ticketBeginners">
            <h2 class="sub-title" style="font-size: 40px">KARNETY</h2>
            <div
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                margin-top: 20px;
              "
            >
              <h3 class="sub-title sub-title-smaller" style="text-align: left">
                {{ `Standardowe:` }}
              </h3>
              <span
                :style="{
                  'font-weight': 600,
                  color: ticket.value > 0 ? '#606C38' : '#CE4257',
                }"
                class="mb-1"
                >{{ ticket.value }}</span
              >
              <span
                v-if="ticket.value && ticket.value > 0"
                style="color: #8b857d; opacity: 0.7"
                class="mb-1"
                >(do {{ formatDateToString(ticket.expirationTime) }})</span
              >
            </div>

            <div
              v-if="ticket.value > 0 && !checkIsExpired(ticket.expirationTime)"
              style="
                cursor: pointer;
                color: #8b857d;
                display: flex;
                gap: 5px;
                align-items: center;
              "
              @click="openStandardCarnetLinks"
            >
              Pokaż linki
              <svg
                width="31"
                height="16"
                viewBox="0 0 31 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
                  fill="#8B857D"
                />
              </svg>
            </div>

            <div
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                margin-top: 20px;
              "
            >
              <h3 class="sub-title sub-title-smaller" style="text-align: left">
                {{ `Dla początkujących:` }}
              </h3>
              <span
                :style="{
                  'font-weight': 600,
                  color: ticketBeginners.value > 0 ? '#606C38' : '#CE4257',
                }"
                class="mb-1"
                >{{ ticketBeginners.value }}</span
              >
              <span
                v-if="ticketBeginners.value && ticketBeginners.value > 0"
                style="color: #8b857d; opacity: 0.7"
                class="mb-1"
                >(do
                {{ formatDateToString(ticketBeginners.expirationTime) }})</span
              >
            </div>

            <div
              v-if="
                ticketBeginners.value > 0 &&
                !checkIsExpired(ticketBeginners.expirationTime)
              "
              style="
                cursor: pointer;
                color: #8b857d;
                display: flex;
                gap: 5px;
                align-items: center;
              "
              @click="openBeginnerCarnetLinks"
              class=""
            >
              Pokaż linki
              <svg
                width="31"
                height="16"
                viewBox="0 0 31 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
                  fill="#8B857D"
                />
              </svg>
            </div>

            <user-links-list-modal
              label="Linki do karnetów standardowych"
              @closeModal="showStandardCarnetLinks = false"
              :isVisible="showStandardCarnetLinks"
              :links="courseTicketsLinks"
              :handleClickedCourseTicketLink="handleClickedCourseTicketLink"
            />
            <user-links-list-modal
              label="Linki do karnetów dla początkujących"
              @closeModal="showBeginnerCarnetLinks = false"
              :isVisible="showBeginnerCarnetLinks"
              :links="courseTicketsBeginnersLinks"
              :handleClickedCourseTicketLink="handleClickedCourseTicketLink"
            />
            <div class="button-wrapper">
              <button
                class="primary-button mt-auto"
                @click="redirectToTicketsList"
              >
                Kup następny karnet
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="workshops" style="margin-top: 40px">
        <div
          v-if="sequencingWorkshops && sequencingWorkshops.length > 0"
          class="profile-card profile-card-with-button"
        >
          <h2 class="sub-title sub-title-smaller-semi-large">
            Warsztaty z sekwencjonowania
          </h2>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              margin-top: 20px;
            "
          >
            <h3 class="sub-title sub-title-smaller" style="text-align: left">
              {{ `aktywne warsztaty:` }}
            </h3>
            <span
              :style="{
                'font-weight': 600,
                'margin-bottom': 10,
                color: sequencingWorkshops.length > 0 ? '#606C38' : '#CE4257',
              }"
              class="mb-1"
              >{{ sequencingWorkshops.length }}</span
            >
          </div>
          <div class="button-wrapper">
            <button
              class="primary-button"
              @click="showSequencingWorkshops = true"
            >
              Szczegóły
            </button>
          </div>
          <workshops-list-modal
            label="Warsztaty z sekwencjonowania"
            @closeModal="showSequencingWorkshops = false"
            :isVisible="showSequencingWorkshops"
            :workshops="sequencingWorkshops"
            :handleWorkshopClick="(e) => moveToSequencingWorkshop(e.id)"
          />
        </div>
        <div
          v-if="tariffWorkshops && tariffWorkshops.length > 0"
          class="profile-card profile-card-with-button"
        >
          <h2 class="sub-title sub-title-smaller-semi-large">
            Warsztaty z taryfami
          </h2>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              margin-top: 20px;
            "
          >
            <h3 class="sub-title sub-title-smaller" style="text-align: left">
              {{ `aktywne warsztaty:` }}
            </h3>
            <span
              :style="{
                'font-weight': 600,
                color: tariffWorkshops.length > 0 ? '#606C38' : '#CE4257',
              }"
              class="mb-1"
              >{{ tariffWorkshops.length }}</span
            >
          </div>
          <div class="button-wrapper">
            <button class="primary-button" @click="showTariffWorkshop = true">
              Szczegóły
            </button>
          </div>
          <workshops-list-modal
            label="Warsztaty z taryfami"
            @closeModal="showTariffWorkshop = false"
            :isVisible="showTariffWorkshop"
            :workshops="tariffWorkshops"
            :handleWorkshopClick="
              (workshop) =>
                checkExpirationTimeIsAfterNow(workshop.expirationTime)
                  ? moveToSequencingWorkshop(workshop.id)
                  : moveToBuyWorkshop(workshop.id)
            "
          />
        </div>
        <div
          v-if="theoryPracticeWorkshops && theoryPracticeWorkshops.length > 0"
          class="profile-card profile-card-with-button"
        >
          <h2 class="sub-title sub-title-smaller-semi-large">
            Warsztaty teoria/praktyka
          </h2>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              margin-top: 20px;
            "
          >
            <h3 class="sub-title sub-title-smaller" style="text-align: left">
              {{ `aktywne warsztaty:` }}
            </h3>
            <span
              :style="{
                'font-weight': 600,
                color:
                  theoryPracticeWorkshops.length > 0 ? '#606C38' : '#CE4257',
              }"
              class="mb-1"
              >{{ theoryPracticeWorkshops.length }}</span
            >
          </div>
          <div class="button-wrapper">
            <button
              class="primary-button"
              @click="showTheoryAndPracticeWorkshop = true"
            >
              Szczegóły
            </button>
          </div>
          <workshops-list-modal
            label="Warsztaty teoria/praktyka"
            @closeModal="showTheoryAndPracticeWorkshop = false"
            :isVisible="showTheoryAndPracticeWorkshop"
            :workshops="theoryPracticeWorkshops"
            :handleWorkshopClick="
              (workshop) => moveToTheoryPracticeWorkshops(workshop.id)
            "
          />
        </div>
        <div
          v-if="specialOffers && specialOffers.length > 0"
          class="profile-card profile-card-with-button"
        >
          <h2 class="sub-title sub-title-smaller-semi-large">
            Oferty specjalne
          </h2>
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              margin-top: 20px;
            "
          >
            <h3 class="sub-title sub-title-smaller" style="text-align: left">
              {{ `aktywne oferty:` }}
            </h3>
            <span
              :style="{
                'font-weight': 600,
                color: specialOffers.length > 0 ? '#606C38' : '#CE4257',
              }"
              class="mb-1"
              >{{ specialOffers.length }}</span
            >
          </div>
          <div class="button-wrapper">
            <button class="primary-button" @click="showSpecialOffers = true">
              Szczegóły
            </button>
          </div>
          <workshops-list-modal
            label="Oferty specjalne"
            @closeModal="showSpecialOffers = false"
            :isVisible="showSpecialOffers"
            :workshops="specialOffers"
            :handleWorkshopClick="(workshop) => moveToSpecialOffer(workshop.id)"
          />
        </div>
      </div>

      <div
        v-if="orders && orders.length > 0"
        style="margin-top: 40px; margin-bottom: 100px"
        class="profile-card orders-container"
      >
        <h2 class="sub-title" style="font-size: 40px">Lista zamówień</h2>

        <div class="orders-list">
          <div
            class="order-card"
            v-for="(order, index) in orders"
            :key="order.id"
          >
            <div class="order-header-section">
              <div class="order-badge">#{{ index + 1 }}</div>
              <div class="order-details">
                <div class="order-date">
                  <span class="order-label">Data zamówienia:</span>
                  <span class="order-value">{{
                    formatDateToString(order.createdAt)
                  }}</span>
                </div>
                <div class="order-total">
                  <span class="order-label">Wartość:</span>
                  <span class="order-value highlight"
                    >{{ order.value }} zł</span
                  >
                </div>
              </div>
            </div>

            <div class="order-content">
              <h3 class="products-title">Zakupione produkty</h3>
              <div class="order-products">
                <div
                  class="product-item"
                  v-for="product in order.shop_orders_products"
                  :key="product.id"
                >
                  <div class="product-image-container">
                    <img
                      v-if="
                        product.shop_product.shop_products_images &&
                        product.shop_product.shop_products_images.find(
                          (image) => image.isMain
                        )
                      "
                      :id="`${product.id}_image`"
                      :src="
                        getProductImageSrc(
                          product.shop_product.shop_products_images.find(
                            (image) => image.isMain
                          )
                        )
                      "
                      alt="Product image"
                      class="product-image"
                    />
                    <img
                      v-else
                      :id="`${product.id}_image`"
                      src="../assets/product-no-photo.jpeg"
                      alt="Product image"
                      class="product-image"
                    />
                  </div>

                  <div class="product-info">
                    <h4 class="product-name">
                      {{ product.shop_product.name }}
                    </h4>
                    <div class="product-quantity">
                      Ilość: {{ product.amount }} szt.
                    </div>

                    <div class="product-attachments">
                      <div
                        v-if="
                          product.shop_product.shop_products_attachments &&
                          product.shop_product.shop_products_attachments
                            .length > 0
                        "
                        class="attachment-container"
                      >
                        <div
                          @click="moveToAttachment(attachment)"
                          v-for="attachment in product.shop_product
                            .shop_products_attachments"
                          :key="attachment.id"
                          class="attachment-button"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
                            ></path>
                          </svg>
                          Pobierz PDF
                        </div>
                      </div>

                      <div
                        v-if="
                          product.shop_product.type === 'PDF' &&
                          product.shop_product.linkForVideos
                        "
                        class="videos-link"
                      >
                        <a :href="product.shop_product.linkForVideos">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <polygon points="23 7 16 12 23 17 23 7"></polygon>
                            <rect
                              x="1"
                              y="5"
                              width="15"
                              height="14"
                              rx="2"
                              ry="2"
                            ></rect>
                          </svg>
                          Lista filmów
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="image-modal">
      <v-dialog v-model="dialogchangepic" width="650">
        <v-card class="px-3 py-3" style="background-color: #d9d9d9">
          <v-file-input
            accept="image/png, image/jpeg, image/jpg"
            placeholder="Wybierz zdjecie profilowe"
            prepend-icon="mdi-camera"
            label="Avatar"
            color="#8B857D"
            v-model="file"
          ></v-file-input>
          <v-btn elevation="2" @click="onUpload" class="primary-button"
            >Zmień zdjęcie</v-btn
          >
        </v-card>
      </v-dialog>
    </div>

    <!-- Modal potwierdzający zamrożenie subskrypcji -->
    <ConfirmModal
      :isVisible="showFreezeConfirmModal"
      title="Zamrażanie subskrypcji"
      :message="freezeConfirmMessage"
      confirmText="Zamroź"
      @closeModal="closeFreezeConfirmModal"
      @confirm="confirmFreezeSubscription"
    />

    <!-- Modal potwierdzający wypisanie się z newslettera -->
    <ConfirmModal
      :isVisible="showUnsubscribeConfirmModal"
      title="Wypisywanie się z newslettera"
      message="Czy na pewno chcesz się wypisać z newslettera? Nie będziesz już otrzymywać wiadomości email od nas."
      confirmText="Wypisz się"
      @closeModal="closeUnsubscribeConfirmModal"
      @confirm="confirmUnsubscribeFromNewsletter"
    />
  </div>
</template>
<script>
import moment from "moment";
import { ValidationObserver } from "vee-validate";
import VTextFieldWithValidation from "../../src/components/inputs/VTextFieldWithValidation";
import { API_URL, SERVER_URL } from "../axios";
import RefLinksInfo from "../components/RefLinksInfo.vue";
import router from "../router";
import UserLinksListModal from "./carnets/UserLinksListModal.vue";
import WorkshopsListModal from "./workshops/WorkshopsListModal.vue";
import ConfirmModal from "../components/modals/ConfirmModal.vue";
import EyeOffIcon from "../components/icons/EyeOffIcon.vue";
export default {
  name: "UserAccount",
  components: {
    VTextFieldWithValidation,
    ValidationObserver,
    RefLinksInfo,
    UserLinksListModal,
    WorkshopsListModal,
    ConfirmModal,
    EyeOffIcon,
  },
  data() {
    return {
      imagePath: "",
      password: "",
      confirmPassword: "",
      dialogchangepic: false,
      file: null,
      showStandardCarnetLinks: false,
      showBeginnerCarnetLinks: false,
      showSequencingWorkshops: false,
      showTariffWorkshop: false,
      showTheoryAndPracticeWorkshop: false,
      showSpecialOffers: false,
      showFreezeConfirmModal: false,
      showUnsubscribeConfirmModal: false,
    };
  },
  metaInfo: {
    title: "Dagajoga konto",
  },
  methods: {
    goToPracticeJournal() {
      this.$router.push({ name: "PracticeJournal" });
    },
    moveToSpecialOffer(id) {
      this.$router.push({
        name: "SpecialOffers",
        params: { id },
      });
    },
    handleClickedCourseTicketLink(id) {
      this.$store.dispatch("coursesTickets/handleClickedLink", id);
    },
    checkExpirationTimeIsAfterNow(expirationTime) {
      return moment(expirationTime).isAfter(moment());
    },
    moveToAttachment(attachment) {
      if (attachment && attachment.path) {
        const splittedPath = attachment.path.split("/");
        const fileName = splittedPath[splittedPath.length - 1];
        const url = `${SERVER_URL}shopProducts/${fileName}`;
        window.open(url, "_blank");
        return url;
      } else {
        return "";
      }
    },

    getProductImageSrc(image) {
      const splittedPath = image.path.split("/");
      const fileName = splittedPath[splittedPath.length - 1];
      return `${SERVER_URL}shopProducts/${fileName}`;
    },

    openChangePhotoModal() {
      this.dialogchangepic = true;
    },
    openBeginnerCarnetLinks() {
      this.showBeginnerCarnetLinks = true;
    },
    openStandardCarnetLinks() {
      this.showStandardCarnetLinks = true;
    },
    async onUpload() {
      let filesAreCorrect = true;
      if (this.file) {
        if (!this.file.type.includes("image")) {
          filesAreCorrect = false;
        }
      }

      if (!filesAreCorrect) {
        this.$store.dispatch("snackbar/showSnackbar", {
          color: "red",
          message:
            "Niepoprawny format pliku. Dozwolone formaty to: jpg, jpeg, png",
        });
        return;
      }

      if (!this.file) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Wybierz zdjęcie profilowe",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }
      await this.$store.dispatch("auth/setProfilePicture", this.file);
      this.imagePath = this.fetchProfileImage(this.profile.id);
      this.imagePath = `${this.imagePath}?time=${new Date().getTime()}`;
      this.$emit("profileImageUpdated");
      this.dialogchangepic = false;
    },

    async handleChangePassword() {
      if (!this.password || !this.confirmPassword) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Uzupełnij wymagane pola do zmiany hasła",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: "Podane hasła muszą być identyczne",
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        return;
      }

      try {
        const response = await this.$store.dispatch("auth/changeOwnPassword", {
          password: this.password,
          confirmPassword: this.confirmPassword,
        });
        if (response) {
          this.$refs.form.reset();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async logout() {
      window.localStorage.setItem("blockTokenCheck", true);
      window.localStorage.removeItem("userToken");
      window.localStorage.removeItem("token");
      this.$store.dispatch("auth/setTokenToNull");
      this.$router.push({ name: "Courses" });
      this.$store.dispatch("timePackages/fetchAllTimePackageItems");
      this.loggedIn = false;
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "success",
          icon: "exclamation-triangle",
          message: "Zostałeś pomyślnie wylogowany",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
    },

    fetchProfileImage(id) {
      return `${API_URL}/profile/${id}/image`;
    },
    formatDateToString(date) {
      if (date) {
        return moment(date).locale("pl").format("DD MMMM YYYY HH:mm");
      }
      return "";
    },
    checkIsExpired(date) {
      return moment(date).isBefore(moment());
    },
    redirect() {
      this.$router.push({
        name: "TimeSubscriptions",
        params: { name: "Courses" },
      });
    },
    redirectExtended() {
      this.$router.push({
        name: "CoursesExtended",
      });
    },

    moveToTariffWorkshop(id) {
      this.$router.push({
        name: "SequencingWorkshops",
        params: { id },
      });
    },

    moveToSequencingWorkshop(id) {
      this.$router.push({
        name: "SequencingWorkshops",
        params: { id },
      });
    },
    moveToBuyWorkshop(id) {
      this.$router.push({
        name: "SequencingWorkshopPayment",
        params: { id },
      });
    },

    moveToTheoryPracticeWorkshops(id) {
      this.$router.push({
        name: "TheoryPracticeWorkshopLessons",
        params: { id },
      });
    },
    redirectToSubscriptionsForBeginners() {
      this.$router.push({
        name: "TimeSubscriptionsForBeginners",
        params: { name: "UserAccount" },
      });
    },
    redirectToTicketsList() {
      window.open("https://dagajoga.pl/index.php/zajecia-online/", "_blank");
    },

    handleFreezeSubscription() {
      this.showFreezeConfirmModal = true;
    },

    async confirmFreezeSubscription() {
      const success = await this.$store.dispatch(
        "timePackages/freezeSubscription"
      );
      if (success) {
        await this.$store.dispatch("auth/checkUserActiveSubscriptions");
        if (this.hasActiveSubscription) {
          await this.$store.dispatch("timePackages/fetchActiveSubscriptions");
        }
        await this.$store.dispatch("timePackages/getCurrentFrozenSubscription");
      }
    },

    closeFreezeConfirmModal() {
      this.showFreezeConfirmModal = false;
    },

    handleUnsubscribeFromNewsletter() {
      this.showUnsubscribeConfirmModal = true;
    },

    async confirmUnsubscribeFromNewsletter() {
      try {
        await this.$store.dispatch(
          "auth/unsubscribeFromNewsletter",
          this.profile.email
        );
        await this.$store.dispatch("auth/fetchUserProfile");
        this.closeUnsubscribeConfirmModal();
      } catch (error) {
        console.log("Błąd podczas wypisywania z newslettera:", error);
      }
    },

    closeUnsubscribeConfirmModal() {
      this.showUnsubscribeConfirmModal = false;
    },
  },
  async created() {
    this.$store.dispatch("coursesTickets/fetchCourseTicketsLinks", {
      type: "STANDARD",
    });
    this.$store.dispatch("coursesTickets/fetchCourseTicketsLinks", {
      type: "BEGINNERS",
    });
    this.$store.dispatch("timePackagesLinks/fetchTimePackagesLinks");
    await this.$store.dispatch(`auth/fetchUserProfile`);
    if (this.profile && this.profile.id) {
      await this.$store.dispatch(`auth/fetchProfilePicture`, this.profile.id);
      await this.$store.dispatch("shopProducts/fetchUserOrders");
      await this.$store.dispatch("coursesTickets/getUserTicketDetails", {
        type: "STANDARD",
      });
      await this.$store.dispatch("coursesTickets/getUserTicketDetails", {
        type: "BEGINNERS",
      });
      await this.$store.dispatch("sequencingWorkshops/getOwnTariffWorkshops");
      await this.$store.dispatch(
        "sequencingWorkshops/getOwnSequencingWorkshops"
      );
      await this.$store.dispatch(
        "theoryPracticeWorkshops/getOwnTheoryPracticeWorkshops"
      );
      await this.$store.dispatch("specialOffers/getOwnSpecialOffers");
    } else {
      router.push({ name: "Auth", params: { previousPage: "UserAccount" } });
    }
    const token = window.localStorage.getItem("userToken");
    if (token) {
      this.imagePath = this.fetchProfileImage(this.profile.id);
    }
    await this.$store.dispatch(`auth/checkUserActiveSubscriptions`);
    await this.$store.dispatch(`auth/checkUserActiveSubscriptionsForBeginners`);
    await this.$store.dispatch(`timePackages/fetchActiveSubscriptionsExtended`);
    if (this.hasActiveSubscription) {
      await this.$store.dispatch(`timePackages/fetchActiveSubscriptions`);
    } else {
      await this.$store.dispatch(`timePackages/setActiveSubscriptionsToNull`);
    }
    await this.$store.dispatch(`timePackages/getCurrentFrozenSubscription`);
    if (this.hasActiveSubscriptionForBeginners) {
      await this.$store.dispatch(
        `timePackages/fetchActiveSubscriptionsForBeginners`
      );
    } else {
      await this.$store.dispatch(
        `timePackages/setActiveSubscriptionsForBeginnersToNull`
      );
    }
  },

  computed: {
    specialOffers() {
      return this.$store.getters["specialOffers/getSpecialOffers"];
    },
    timePackagesLinksForBeginners() {
      if (!this.hasActiveSubscriptionForBeginners) {
        return [];
      }
      return this.$store.getters[
        "timePackagesLinks/getTimePackagesLinksForBeginner"
      ];
    },
    timePackagesLinksForGeneral() {
      if (!this.hasActiveSubscription) {
        return [];
      }
      return this.$store.getters[
        "timePackagesLinks/getTimePackagesLinksForGeneral"
      ];
    },
    ticket() {
      return this.$store.getters["coursesTickets/getUserTicket"];
    },
    ticketBeginners() {
      return this.$store.getters["coursesTickets/getUserTicketBeginners"];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
    activeSubscriptions() {
      return this.$store.getters["timePackages/getActiveSubscriptions"];
    },
    activeSubscriptionsExtended() {
      return this.$store.getters["timePackages/getActiveSubscriptionsExtended"];
    },
    activeSubscriptionsForBeginners() {
      return this.$store.getters[
        "timePackages/getActiveSubscriptionsForBeginners"
      ];
    },
    hasActiveSubscription() {
      return this.$store.getters["auth/getHasActiveSubscription"];
    },
    hasActiveSubscriptionForBeginners() {
      return this.$store.getters["auth/getHasActiveSubscriptionForBeginners"];
    },
    orders() {
      return this.$store.getters["shopProducts/getShopProductsOrders"];
    },
    tariffWorkshops() {
      return this.$store.getters["sequencingWorkshops/getUserTariffWorkshops"];
    },
    sequencingWorkshops() {
      return this.$store.getters["sequencingWorkshops/getSequencingWorkshops"];
    },
    theoryPracticeWorkshops() {
      return this.$store.getters[
        "theoryPracticeWorkshops/getTheoryPracticeWorkshops"
      ];
    },
    courseTicketsLinks() {
      return this.$store.getters["coursesTickets/getCoursesTicketsLinks"];
    },
    courseTicketsBeginnersLinks() {
      return this.$store.getters[
        "coursesTickets/getCoursesTicketsBeginnersLinks"
      ];
    },
    canFreezeSubscription() {
      if (!this.activeSubscriptions || this.activeSubscriptions.length === 0) {
        return false;
      }
      // Sprawdzamy najnowszą aktywną subskrypcję
      const latestSubscription = this.activeSubscriptions.reduce(
        (latest, current) => {
          return new Date(current.expiration_time) >
            new Date(latest.expiration_time)
            ? current
            : latest;
        }
      );

      // Sprawdzamy czy ma ustawioną liczbę dni zamrażania i czy nie jest już zamrożona
      const canFreeze =
        latestSubscription.time_package &&
        latestSubscription.time_package.numberOfDaysSubscriptionFreeze &&
        latestSubscription.time_package.numberOfDaysSubscriptionFreeze > 0 &&
        !this.currentFrozenSubscription;

      return canFreeze;
    },
    currentFrozenSubscription() {
      return this.$store.getters["timePackages/getCurrentFrozenSubscription"];
    },
    freezeConfirmMessage() {
      if (!this.activeSubscriptions || this.activeSubscriptions.length === 0) {
        return "";
      }

      const latestSubscription = this.activeSubscriptions.reduce(
        (latest, current) => {
          return new Date(current.expiration_time) >
            new Date(latest.expiration_time)
            ? current
            : latest;
        }
      );

      if (
        !latestSubscription.time_package ||
        !latestSubscription.time_package.numberOfDaysSubscriptionFreeze
      ) {
        return "";
      }

      const numberOfDays =
        latestSubscription.time_package.numberOfDaysSubscriptionFreeze;
      const freezeEndDate = new Date();
      freezeEndDate.setDate(freezeEndDate.getDate() + numberOfDays);

      return `Czy na pewno chcesz zamrozić subskrypcję?</br>
      Subskrypcja pozostanie zablokowana do dnia: ${this.formatDateToString(
        freezeEndDate
      )}.</br>
      Twoja aktualna subskrypcja zostanie przedłużona do dnia ${this.formatDateToString(
        moment(latestSubscription.expiration_time).add(numberOfDays, "days")
      )}.`;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-link {
  cursor: pointer;
  color: #1976d2;
  text-decoration: underline;
  font-weight: 500;
}
.order-product {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
}
.order-product-info p {
  margin: 0;
}
.order-product img {
  width: 100px;
  object-fit: contain;
}
.order {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-radius: 16px;
  margin-bottom: 1rem;
}
.orders {
  width: 100%;
}
.order-header {
  margin-bottom: 0;
  color: #54514c;
}
.packages-container {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  width: 100%;
}
.container {
  height: 100%;
  min-width: 100%;
  margin: 0;
  padding: 0;
  max-width: 2560px;
}
.content {
  padding-left: 7%;
  padding-right: 7%;
  padding-bottom: 100px;
  @media (max-width: 1024px) {
    padding-left: 3.5%;
  }
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  .path {
    a {
      color: #000;
      text-decoration: none;
      font-weight: 500;
    }
    @media (max-width: 425px) {
      margin-top: -2rem;
      padding-bottom: 20px !important;
    }
  }
}
.logout-row {
  display: flex;
  align-items: center;
}
.profile {
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  margin-right: 2rem;
  width: 200px;
  justify-content: center;
  align-items: center;
}
.profile-image {
  width: 150px;
  height: 150px;
  border-radius: 1000px;
  object-fit: cover;
}

.zoom-link a {
  text-decoration: none;
  color: #54514c;
}

a:hover {
  text-decoration: underline;
}
.no-links {
  color: #807e7e;
  text-align: center;
}
/* HEADER */
h1 {
  font-size: 80px;
  text-transform: uppercase;
  font-family: Vollkorn SC;
  font-weight: 400;
  color: #d9d9d9;
  text-align: center;
  margin-top: 30px;
}
.invite-and-zoom {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 40px;
}
.invite {
  width: 48%;
  max-width: 48%;
}
.zoom {
  width: 100%;
  min-width: 100%;
}
.profile-card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px;
  position: relative;
  padding: 40px;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}

.profile-card-with-button {
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.button-wrapper {
  margin: auto;
  margin-top: 30px;
  width: fit-content;
}

.remember-zoom {
  font-size: 12px;
  color: #6d6963;
  text-align: center;
  margin-top: 5px;
}
.profile-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto;
  margin-top: 40px;
  gap: 40px;
}
.workshops {
  display: grid;
  gap: 40px;
  grid-template-columns: 1fr 1fr;
}

.span-height {
  height: 100%;
  grid-row: span 3;
}

.profile-image-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
label {
  font-weight: 400;
  font-size: 12px;
  color: #6d6963;
}
.redirect-to-subscriptions {
  color: #8b857d;
  font-weight: 500;
  margin-right: 10px;
  margin-left: 10px;
}
.sub-title-smaller {
  font-size: 26px;
}
.sub-title-smaller-semi-large {
  font-size: 30px;
}

@media screen and (max-width: 1300px) {
  .invite-and-zoom {
    flex-direction: column;
  }
  .invite {
    width: 100%;
    max-width: 100%;
  }
  .profile-grid {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 1000px) {
  .workshops {
    grid-template-columns: 1fr;
  }
  h1 {
    font-size: 50px;
  }
}
@media screen and (max-width: 500px) {
  .profile-card {
    padding: 20px;
  }
  .sub-title-smaller {
    font-size: 13px;
  }
  .sub-title-smaller-semi-large {
    font-size: 20px;
  }
}

.orders-container {
  overflow: hidden;
}

.orders-list {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.order-card {
  background: #f1f1f1;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 6px 15px rgba(182, 175, 165, 0.15);
  transition: transform 0.2s, box-shadow 0.2s;
}

.order-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(182, 175, 165, 0.25);
}

.order-header-section {
  background: #c5c0b9;
  //  background: linear-gradient(90deg, rgba(197, 192, 185, 1) 0%, rgba(255, 255, 255, 1) 100%);
  padding: 20px 25px;
  display: flex;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.order-badge {
  background: #8b857d;
  // background: #C5C0B9;
  color: white;
  font-weight: 600;
  border-radius: 100px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.order-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
}

.order-date,
.order-total {
  display: flex;
  align-items: center;
  gap: 10px;
}

.order-label {
  color: #8b857d;
  font-size: 14px;
  font-weight: 500;
}

.order-value {
  color: #54514c;
  font-weight: 600;
}

.order-value.highlight {
  color: #54514c;
}

.order-content {
  padding: 25px;
}

.products-title {
  font-size: 18px;
  font-weight: 600;
  color: #54514c;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px dashed rgba(139, 133, 125, 0.2);
}

.order-products {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.product-item {
  display: flex;
  gap: 20px;
  background: white;
  padding: 15px;
  border-radius: 16px;
  transition: transform 0.15s;
}

.product-item:hover {
  transform: translateX(5px);
}

.product-image-container {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-name {
  font-weight: 600;
  color: #54514c;
  font-size: 16px;
  margin: 0;
}

.product-quantity {
  color: #8b857d;
  font-size: 14px;
}

.product-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.attachment-container {
  display: flex;
  gap: 10px;
}

.attachment-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #d9d9d9;
  color: #6d6963;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.attachment-button:hover {
  background: #e5e5e5;
}

.videos-link a {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #d9d9d9;
  color: #6d6963;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  text-decoration: none;
  transition: background 0.2s, transform 0.1s;
}

.videos-link a:hover {
  background: #e5e5e5;
}

@media screen and (max-width: 768px) {
  .order-details {
    flex-direction: column;
    align-items: flex-start;
  }

  .product-item {
    flex-direction: column;
  }

  .product-image-container {
    width: 100%;
    height: 140px;
  }
}

@media screen and (max-width: 500px) {
  .order-header-section {
    padding: 15px;
  }

  .order-content {
    padding: 15px;
  }

  .order-badge {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
}
</style>
